import { type ReactNode, useCallback } from 'react';

import type { FormAsyncComboboxProps } from '@/_components';
import { FormAsyncCombobox, PrimaryLink } from '@/_components';

import { useGetInfrastructuresMutation } from '../apis';
import type { InfrastructureQueryLinkerSchema } from '../schemas';

export function InfrastructuresAsyncSelect({
  disabled,
  ...props
}: FormAsyncComboboxProps<InfrastructureQueryLinkerSchema>) {
  const getName = useCallback(
    (item?: InfrastructureQueryLinkerSchema | null): ReactNode => {
      if (!item) {
        return '';
      }

      const itemName = item.name;

      if (!disabled) {
        return itemName;
      }
      return (
        <PrimaryLink to="/settings/infrastructures/$id" params={{ id: `${item.id}` }} state={{ naturalBack: true }}>
          {itemName}
        </PrimaryLink>
      );
    },
    [disabled]
  );

  return (
    <FormAsyncCombobox
      {...props}
      itemToString={getName}
      keyExtractor={(item) => item?.id?.toString?.() ?? null}
      useApi={useGetInfrastructuresMutation}
      disabled={disabled}
    />
  );
}
